import styled from 'styled-components';
import { isMobile } from '../../../../../common/utils';

export const Container = styled.div`
  display: flex;
  gap: 8px;

  ${isMobile &&
  `
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    ion-chip {
    flex-shrink: 0;
  }
  `}
`;
